console.log('Eric - Selluxe Dev');

const customCardATC = document.querySelectorAll('.custom-card-atc');

if(customCardATC.length > 0) {
  customCardATC.forEach(atc => {
    const productId = atc.dataset.productId;
    const quantity = parseInt(atc.dataset.quantity, 10);
    
    atc.addEventListener('click', async () => {
      if(productId && quantity) {
        atc.classList.add('loading');
        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                items: [{ id: productId, quantity: quantity }]
            })
          });
          
          if (response.ok) {
            const data = await response.json();
            console.log('Product added to cart:', data);
          } else {
            console.error('Error adding to cart:', response.statusText);
          }
        } catch (error) {
          console.error('Request failed', error);
        }

        atc.classList.remove('loading');
      }
    });
  });
}

const getElementScrollHeight = (element) => {
  const scrollHeight = element.getBoundingClientRect().top + window.scrollY;
  return scrollHeight;
}

function checkIfPassedElement(targetSelector, elementToShow) {
  const targetScrollHeight = getElementScrollHeight(targetSelector);
  
  if (targetScrollHeight !== null) {
    window.addEventListener('scroll', function() {
      const currentScrollY = window.scrollY;

      if (currentScrollY > targetScrollHeight) {
        elementToShow.classList.add('active');
        
      } else {
        elementToShow.classList.remove('active');
      }
    });
  }
}

const stickyAtcToggler = () => {
  const stickyAtc = document.querySelector('#selluxe-sticky-atc');
  const stickyAtcButton = stickyAtc.querySelector('button');
  const productForm = document.querySelector('.product-single__form');
  const formBtn = productForm.querySelector('button.add-to-cart');

  if(productForm) {
    checkIfPassedElement(productForm, stickyAtc);
  }

  if(stickyAtcButton) {
    stickyAtcButton.addEventListener('click', () => {
      formBtn.click();
    })
  }
}

stickyAtcToggler();